/**
 * 进入游戏前置
 *
 * @function fetchGameList
 */
import { AxiosError } from "axios";

import { NetExtGame, NetFront } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import { CollectGameReq, MyGameListRsp } from "@/types/swagger/appserver";
import {
  EnterGameReq,
  EnterGameRsp,
  GetPromoFeedDataNewReq,
  GetPromoFeedDataNewRsp,
  SearchSportsDataReq,
  SearchSportsDataRsp,
} from "@/types/swagger/extGame";
import {
  GetUserLiveStatsReq,
  GetUserLiveStatsRsp,
} from "@/types/swagger/front";

export const postEnterGame = (
  params: EnterGameReq,
  needToken = false,
  onTimeout?: () => void,
  onError?: (error: AxiosError) => void,
) => {
  return reqPost<EnterGameReq, EnterGameRsp>(
    params,
    NetExtGame.mod,
    NetExtGame.EnterGame,
    needToken,
    onTimeout,
    onError,
  );
};

export const postCollectGame = (params: CollectGameReq) => {
  return reqPost<CollectGameReq, MyGameListRsp>(
    params,
    NetFront.mod,
    NetFront.CollectGame,
    true,
  );
};

export const postGetUserLiveStats = (params: GetUserLiveStatsReq) => {
  return reqPost<GetUserLiveStatsReq, GetUserLiveStatsRsp>(
    params,
    NetFront.mod,
    NetFront.GetUserLiveStats,
    true,
  );
};
export const GetPromoFeedDataNew = (params: GetPromoFeedDataNewReq) => {
  return reqPost<GetPromoFeedDataNewReq, GetPromoFeedDataNewRsp>(
    params,
    NetExtGame.mod,
    "NA.GetPromoFeedDataNew",
    false,
  );
};

// 体育搜索
export const postSearchSportsData = (params: SearchSportsDataReq) => {
  return reqPost<SearchSportsDataReq, SearchSportsDataRsp>(
    params,
    NetExtGame.mod,
    NetExtGame.SearchSportsData,
    false,
  );
};
